import React, { useContext, useEffect, useState } from 'react'
import { Container, ContainerOutlet } from './style'
import UserContext from '../../contexts/UserContext'
import jwtDecode, { JwtPayload } from 'jwt-decode'
import ModalContext from '../../contexts/ModalContext'
import BaseModal from '../../components/Modal'
import FeedbackComponent from '../../components/FeedbackComponent'
import { FeedbackContext } from '../../contexts/FeedbackContext'
import { Outlet } from 'react-router-dom' // <-- Importando Outlet
import HeaderComponent from '../../components/Header'

interface DecodedUser extends JwtPayload {
  email: string
  name: string
}

export interface TypeMainOutlet {
  search: string
  setSearch: React.Dispatch<React.SetStateAction<string>>
}

const ClientPanel = () => {
  const { user } = useContext(UserContext)
  const { modalActive } = useContext(ModalContext)
  const { feedback } = useContext(FeedbackContext)
  const [ search, setSearch ] = useState<string>('')

  useEffect(() => {
    const accessToken = localStorage.getItem('token')
    if (accessToken) {
      const decodedUser = jwtDecode(accessToken) as DecodedUser
    }
  }, [])

  if (!user) {
    return null
  }

  if (!user.approved) {
    localStorage.removeItem('token')
    window.location.href = '/'
  }

  if (user.approved !== 'approved') {
    window.location.href = '/accessvalidation'
  }

  return (
    <Container>
      <HeaderComponent search={search} setSearch={setSearch}  />
      {modalActive && <BaseModal />}
      {feedback.isOpen && <FeedbackComponent />}
      <ContainerOutlet>
        <Outlet context={{
          search,
          setSearch
        }} />
      </ContainerOutlet>
    </Container>
  )
}

export default ClientPanel
